(function() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('discount');
  if (code) {
    localStorage.setItem('cl_referral_discount', JSON.stringify({
      code: code,
      capturedAt: Date.now()
    }));
  }
})();

function getValidReferralCode() {
  const raw = localStorage.getItem('cl_referral_discount');
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
    if (Date.now() - data.capturedAt > THIRTY_DAYS) {
      localStorage.removeItem('cl_referral_discount');
      return null;
    }
    return data.code;
  } catch (e) {
    return null;
  }
}